import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom'
import {Button, InlineNotification, InputField} from '@elixir/components';
import './loginForm.scss';
import LoginContainer from '../loginContainer';

import crypto from '../common/crypto';
import {PostRequest} from '../../common/service/PostRequest';
import FormTitle from '../common/formTitle/formTitle';

export default class LoginForm extends React.Component {

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            errorMessage: null,
            username: '',
            password: ''
        };
    }

    onUsernameChange (newValue) {
        this.setState({
            username: newValue,
            errorMessage: null
        });
    }

    onPasswordChange (newValue) {
        this.setState({
            password: newValue,
            errorMessage: null
        });
    }

    onLogin (isSubmitDisabled) {

        if (!isSubmitDisabled) {
            const {username, password} = this.state;
            const data = {
                userName: username,
                password: crypto.encryptWithServerPublicKey(password)
            };
            const tokenTimeoutLength = 86400 * 365; //one year
            const loginUrl = new URL('rest/v2/Session', window.location.origin);
            const params = {
                applicationId: 'OPERATOR',
                timeoutSeconds: tokenTimeoutLength
            };
            loginUrl.search = new URLSearchParams(params);
            const request = new PostRequest();

            request.post(loginUrl, data).then(
                (result) => {
                    if (result.errorMessage) {
                        const node = ReactDOM.findDOMNode(this);
                        const usernameInput = node.querySelector('#usernameInput');
                        usernameInput.focus();

                        this.setState({
                            username: '',
                            password: '',
                            errorMessage: result.errorMessage
                        });
                    }
                    else {
                        this.setState({errorMessage: null});

                        window.localStorage.setItem('loginToken::operator', result);

                        this.props.history.push('/app/user');
                    }
                },
                (error) => {
                    if (error.errorMessage) {
                        this.setState({errorMessage: error.errorMessage});
                    }
                }
            );
        }
    }

    render () {
        const {
            errorMessage,
            username,
            password
        } = this.state;

        const loginContainerTitle = this.context.translator('login.loginTitle');
        const forgotPasswordButtonLabel = this.context.translator('login.forgotPasswordButtonLabel');
        const loginButtonLabel = this.context.translator('login.loginButtonLabel');

        const hasUsernameFilled = username.length > 0;
        const hasPasswordFilled = password.length > 0;
        const isLoginButtonDisabled = !(hasPasswordFilled && hasUsernameFilled && !errorMessage);

        let error = '';

        if (errorMessage) {
            error = (<InlineNotification className="loginError"
                                         type="error"
                                         isDismissable={false}
                                         message={errorMessage}/>);
        }

        return (
            <LoginContainer
                onEnterKeydown={this.onLogin.bind(this, isLoginButtonDisabled)}
                title={loginContainerTitle}>

                <div className="loginFormComponent">

                    <div className="errorContainer">
                        {error}
                    </div>

                    <FormTitle titleKey="login.loginTitle"/>

                    <InputField
                        className="username"
                        id="usernameInput"
                        controlClassName="usernameInput"
                        onValueChange={this.onUsernameChange.bind(this)}
                        value={username}
                        label="login.usernameInputLabel"/>

                    <InputField
                        className="password"
                        id="passwordInput"
                        inputType="password"
                        onValueChange={this.onPasswordChange.bind(this)}
                        value={password}
                        label="login.passwordInputLabel"/>


                    <div className="forgotPasswordContainer">
                        <Link to="/forgotpassword"
                              className="forgotPasswordButton">{forgotPasswordButtonLabel}</Link>
                    </div>

                    <Button className="actionButton loginButton"
                            name="testButton"
                            type="primary"
                            onClick={this.onLogin.bind(this, isLoginButtonDisabled)}
                            disabled={isLoginButtonDisabled}>

                        <span>{loginButtonLabel}</span>
                    </Button>

                </div>
            </LoginContainer>
        );
    }
}